/**
 * @ignore
 *
 * The root store file.
 *
 * We also persist the Redux store <https://www.npmjs.com/package/redux-persist> so that refreshing the page doesn't reset the store to initial values.
 */
import { createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import reducers from './reducers'; // n.b. this is the "root" reducer


// for Redux persistence; see <https://www.npmjs.com/package/redux-persist>:
// currently using default merge level; see <https://github.com/rt2zz/redux-persist#state-reconciler> if we want to change config:
const persistConfig = {
    key: 'root',
    storage,
};

const persistedReducer = persistReducer(persistConfig, reducers);

export default () => {
    let store = createStore(persistedReducer);
    let persistor = persistStore(store);

    return { store, persistor };
};
